import { useCallback, useState } from 'react';

export function useTablePager({
  startPage = 1,
  perPage = 25
}: {
  startPage?: number;
  perPage?: number;
} = {}) {
  const [page, setPage] = useState(startPage);

  const openNextPage = useCallback(() => {
    setPage(currentPage => currentPage + 1);
  }, []);

  const openPrevPage = useCallback(() => {
    setPage(currentPage => currentPage - 1);
  }, []);

  const offset = (page - 1) * perPage;

  return {
    page,
    offset,
    openNextPage,
    openPrevPage
  };
}
